import styled from 'styled-components';

export const Container = styled.div`
  .swiper-carousel {
    .swiper-container {
      padding-bottom: 30px;
    }
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0;
  }
`;

export default Container;
